<template>
  <div>
    <div v-if="isLoading" class="loading">
      <svg viewBox="-2000 -1000 4000 2000">
        <path id="inf" d="M354-354A500 500 0 1 1 354 354L-354-354A500 500 0 1 0-354 354z"></path>
        <use xlink:href="#inf" stroke-dasharray="1570 5143" stroke-dashoffset="6713px"></use>
      </svg>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'app',
    computed: {
      ...mapState({
        isLoading: state => state.isLoading
      })
    }
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// App.vue?c860ee62